export const defined = (value) => {
  if (typeof value === 'undefined') throw new Error('undefined')
  return value
}
